import { gql } from '@apollo/client';

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer(
    $termsOfUse: String
    $privacyPolicy: String
    $emailVerificationAcceptedTitle: String
    $emailVerificationAcceptedFromName: String
    $emailVerificationAcceptedContent: String
    $emailVerificationCompletedTitle: String
    $emailVerificationCompletedFromName: String
    $emailVerificationCompletedContent: String
  ) {
    updateCustomer(
      termsOfUse: $termsOfUse
      privacyPolicy: $privacyPolicy
      emailVerificationAcceptedTitle: $emailVerificationAcceptedTitle
      emailVerificationAcceptedFromName: $emailVerificationAcceptedFromName
      emailVerificationAcceptedContent: $emailVerificationAcceptedContent
      emailVerificationCompletedTitle: $emailVerificationCompletedTitle
      emailVerificationCompletedFromName: $emailVerificationCompletedFromName
      emailVerificationCompletedContent: $emailVerificationCompletedContent
    ) {
      id
      companyName
      companyLogoImage
      termsOfUse
      privacyPolicy
      emailVerificationAcceptedTitle
      emailVerificationAcceptedFromName
      emailVerificationAcceptedContent
      emailVerificationCompletedTitle
      emailVerificationCompletedFromName
      emailVerificationCompletedContent
      createdAt
      updatedAt
      isDeleted
    }
  }
`;
